export default __webpack_public_path__ + "static/media/learose-480w.20670549.webp";